module.exports = __webpack_public_path__ + "img/carousel-02-md.28fbbf6b.png";